<template>
  <div id="viewTemplate">
    <v-card>
      <v-layout>
        <v-flex class="pr-2 pl-2">
          <v-text-field
            v-model="viewSearch"
            append-icon="search"
            label="Search by Name / Membership"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="viewHeaders"
        :items="data.account"
        :search="viewSearch"
        no-data-text="No views found"
        :pagination.sync="viewPagination"
        class="pf-data-table"
      >
        <template v-slot:items="props">
          <tr v-if="props.item">
            <td>{{ props.index + 1 }}</td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.membership }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
/* global session config store moment */
import { formatDate } from '../../helpers/helpers';
export default {
  name: 'app-view',
  props: ['data'],
  data: () => ({
    config: config,
    viewSearch: '',
    viewHeaders: [
      { text: '#', value: 'id', align: 'left' },
      { text: 'Name', value: 'name', align: 'left' },
      { text: 'Membership', value: 'membership' },
    ],
    viewPagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: ''
    }
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  watch: {
    $props: {
      handler () {
        this.viewSearch = '';
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    formatDateMethod (date, format = 'MM/DD/YYYY') {
      return formatDate(date, format);
    }
  }
};
</script>
<style scoped>
  /*  */
</style>



// WEBPACK FOOTER //
// src/pages/Invoices/view.vue